import { Component, OnInit, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../services/tools/helpers.service';
import { ReportsHelperService } from '../../../../services/tools/reports-helpers.service';
import { ReportesConcentradosService } from '../../../../services/reportes/reportes-concentrados.service';

@Component({
    selector: 'concentrados-pagos',
    templateUrl: './concentrados-pagos.component.html'
  })

export class ConcentradosPagosComponent implements OnInit {
  @Output() public onAfterLoad : EventEmitter<void> = new EventEmitter;

  public errors: any = {};
  public pagos: any = [];
  public totales: any = {};

  constructor(
    private helperService: HelpersService,
    private reportesService: ReportesConcentradosService,
    private helperReportService: ReportsHelperService
  ){
  }

  public ngOnInit() {
  }

  public update(filters: any){

    this.reportesService.pagos(filters).subscribe(
      (response) =>
      {
        const jsonResult = response.json();
        let items = [];
        let totales = {};
        let content = jsonResult.content;
        
        if(content && content.items){
          this.pagos = content.items;
        }

        if(content && content.totales){
          totales = content.totales;
        }
        this.totales = totales;
        this.onAfterLoad.emit();
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public descargar(filters: any){
    this.reportesService.pagos(filters, true).subscribe(
        (response)=>
        {
          const fileUrl = window.URL.createObjectURL(response.blob());
          //Muestra el archivo en una nueva ventana
          window.open(fileUrl);
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);

          if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/reportes/concentrados/components/concentrados-pagos/concentrados-pagos.component.ts